/**
 * Rock Off Retail — "Find Your World" concert-light pointer effect.
 * Only binds on fine-pointer devices with motion allowed; touch devices and
 * prefers-reduced-motion visitors simply get the CSS gradient's static
 * default position (no listener attached at all).
 */
if (
  window.matchMedia('(pointer: fine)').matches &&
  !window.matchMedia('(prefers-reduced-motion: reduce)').matches
) {
  document.querySelectorAll('.ro-dbox').forEach((box) => {
    box.addEventListener('pointermove', (e) => {
      const r = box.getBoundingClientRect();
      box.style.setProperty('--mx', `${(((e.clientX - r.left) / r.width) * 100).toFixed(1)}%`);
    });
  });
}
